import { IResult } from '../types/IResponse';
import { ISiteOIDCConfiguration } from '../types/ISiteOIDCConfiguration';
import { Request } from './Request';

export interface ICreateOrUpdateSiteOIDCConfigurationParams {
  siteOIDCConfiguration: ISiteOIDCConfiguration;
}

export class CreateOrUpdateSiteOIDCConfigurationRequest extends Request<ICreateOrUpdateSiteOIDCConfigurationParams, IResult> {
  constructor(params: ICreateOrUpdateSiteOIDCConfigurationParams) {
    super('createOrUpdateSiteOIDCConfiguration', params);
  }
}
